// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__TMqG6","footerText":"Footer_footerText__pePnn"};